import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-043b0814"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cccd-scanner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "scan-box" })
], -1))
const _hoisted_3 = { class: "toolbar" }
const _hoisted_4 = {
  key: 0,
  class: "result"
}

import { BrowserMultiFormatReader } from "@zxing/browser";
import { ref, onMounted, onUnmounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  emits: ["success", "error"],
  setup(__props, { emit }) {



const videoRef = ref<HTMLVideoElement | null>(null);

const result = ref("");

const isScanning = ref(false);

const reader = new BrowserMultiFormatReader();

let controls: any = null;

async function startScan() {
  if (isScanning.value) return;

  isScanning.value = true;

  try {

    const devices =
        await BrowserMultiFormatReader.listVideoInputDevices();

    if (devices.length === 0) {

      emit("error", "Không tìm thấy camera");

      isScanning.value = false;

      return;
    }

    let deviceId = devices[0].deviceId;

    const backCamera = devices.find(d => {

      const name = d.label.toLowerCase();

      return (
          name.includes("back") ||
          name.includes("rear") ||
          name.includes("environment")
      );

    });

    if (backCamera) {
      deviceId = backCamera.deviceId;
    }

    controls = await reader.decodeFromVideoDevice(
        deviceId,
        videoRef.value!,
        (resultDecode) => {

          if (!resultDecode) return;

          result.value = resultDecode.getText();

          emit("success", result.value);

          stopScan();

        }
    );

  } catch (e) {

    emit("error", e);

    stopScan();

  }
}

function stopScan() {

  isScanning.value = false;

  try {

    if (controls) {
      controls.stop();
      controls = null;
    }

    reader.reset();

    const video = videoRef.value;

    if (video && video.srcObject) {

      const stream = video.srcObject as MediaStream;

      stream.getTracks().forEach(track => track.stop());

      video.srcObject = null;

    }

  } catch (e) {
    console.error(e);
  }
}

onMounted(() => {

  startScan();

});

onUnmounted(() => {

  stopScan();

});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      ref: (_value, _refs) => {
        _refs['videoRef'] = _value
        videoRef.value = _value
      },
      autoplay: "",
      playsinline: "",
      muted: "",
      class: "camera"
    }, null, 512),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        label: "Mở Camera",
        icon: "pi pi-camera",
        onClick: startScan,
        disabled: isScanning.value
      }, null, 8, ["disabled"]),
      _createVNode(_component_Button, {
        label: "Dừng",
        icon: "pi pi-stop",
        class: "p-button-danger",
        onClick: stopScan
      })
    ]),
    (result.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(result.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})